







































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { getFormattedDateTime } from "@/utility/DateUtils";
import { PESAN_VERIFIKASI_TERKUNCI } from "@/utility/PemeriksaanReadonly";
import {
  bandingRencana,
  jumlahBarisDiagnosis,
  kelompokkan,
  perluVerifikasi,
  unitKode
} from "@/utils/askepRencana";

const DIAGNOSIS_KOSONG = [null];

@Component({
  inject: {
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class PerencanaanTable extends Vue {
  @Prop({ type: String, default: "20vh" }) height!: string;
  @Prop({ type: Array, default: () => [] }) planningList!: any[];
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop({ type: Boolean, default: false }) essentialOnly!: boolean;
  @Prop({ type: Boolean, default: false }) readonly!: boolean;
  @Prop({ type: Boolean, default: false }) canSelectIntervensi!: boolean;
  @Prop({ type: Boolean, default: false }) canCopy!: boolean;
  @Prop({ type: Object, default: null }) stoppingItem!: number | null;
  @Prop({ type: Object, default: null }) deletingItem!: number | null;
  @Prop({ type: Object, default: null }) verifyingItem!: number | null;

  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  get user() {
    return userModule.user;
  }

  get unitSaya(): string {
    return userModule.scopedUnitId || "";
  }

  get canVerify(): boolean {
    return userModule.hasPrivilege("perencanaan-askep", "verify");
  }

  get list() {
    return this.planningList;
  }

  get grupList() {
    return kelompokkan(this.list.slice().sort(bandingRencana));
  }

  formatDate(dateStr: string) {
    return getFormattedDateTime(dateStr, "YYYY-MM-DD HH:mm");
  }

  barisDiagnosis(row: any) {
    const isi = Array.isArray(row.content) ? row.content : [];

    return isi.length ? isi : DIAGNOSIS_KOSONG;
  }

  jumlahDiagnosis(row: any): number {
    return jumlahBarisDiagnosis(row);
  }

  kunciBaris(grup: any, row: any, ri: number, idxDiag: number): string {
    const id = row.id ? `id${row.id}` : `baru${grup.nomor}-${ri}`;

    return `${id}-${idxDiag}`;
  }

  grupTerhenti(grup: any): boolean {
    return grup.baris.every((b: any) => !!b.stopped_at);
  }

  perluVerifikasiBaris(row: any): boolean {
    return perluVerifikasi(row);
  }

  bolehVerifikasi(row: any): boolean {
    if (!this.unitSaya) return true;

    const kode = unitKode(row);
    if (kode && kode === this.unitSaya) return true;

    const kini = row.unit_pasien_kini;

    return !!kini && String(kini) === this.unitSaya;
  }

  judulVerifikasi(row: any): string {
    if (this.verifikasiTerkunci) return PESAN_VERIFIKASI_TERKUNCI;
    if (this.bolehVerifikasi(row)) return "Verifikasi";

    const kode = unitKode(row) || "-";

    return `Hanya PPJA di ruang ${kode} (atau ruang pasien saat ini) yang dapat memverifikasi`;
  }

  bisaUbah(row: any): boolean {
    if (row.verified_at) return this.canVerify;
    if (this.canVerify) return true;
    if (!row.user) return false;

    return String(row.user.id) === String(this.user.id);
  }

  sudahDisalin(row: any): boolean {
    return this.list.some(
      (r: any) => r.salinan_dari_id === row.id && !r.stopped_at
    );
  }

  bisaSalin(row: any): boolean {
    if (!this.canCopy || !row.id) return false;
    if (row.stopped_at) return false;
    if (this.unitSaya && unitKode(row) === this.unitSaya) return false;

    return !this.sudahDisalin(row);
  }

  judulSalin(row: any): string {
    if (!row.id) return "Simpan dulu sebelum dapat disalin";
    if (!this.canCopy) return "Menunggu master diagnosis dimuat";
    if (row.stopped_at) return "Perencanaan yang dihentikan tidak dapat disalin";
    if (this.unitSaya && unitKode(row) === this.unitSaya) {
      return "Perencanaan ini sudah milik ruang Anda";
    }
    if (this.sudahDisalin(row)) {
      return "Perencanaan ini sudah disalin dan salinannya masih aktif";
    }

    const kode = unitKode(row) || "-";

    return `Salin diagnosa & perencanaan dari ruang ${kode}`;
  }

  isStopping(row: any): boolean {
    return this.stoppingItem === (row.id || null);
  }

  isDeleting(row: any): boolean {
    return this.deletingItem === (row.id || null);
  }

  isVerifying(row: any): boolean {
    return this.verifyingItem === (row.id || null);
  }

  onEditPlanning(row: any) {
    this.$emit("editPlanning", row);
  }

  onSalinPlanning(row: any) {
    this.$emit("salinPlanning", row);
  }

  onMovePlanningUp(grup: any) {
    this.$emit("movePlanningUp", grup);
  }

  onMovePlanningDown(grup: any) {
    this.$emit("movePlanningDown", grup);
  }

  onStopPlanning(row: any) {
    this.$emit("stopPlanning", row);
  }

  onResumePlanning(row: any) {
    this.$emit("resumePlanning", row);
  }

  onDeletePlanning(row: any) {
    this.$emit("deletePlanning", row);
  }

  onVerifyPlanning(row: any) {
    this.$emit("verifyPlanning", row);
  }

  onAddToImplementation(item: any) {
    this.$emit("addToImplementation", item);
  }

  isTimeout(lua: any, row: any): boolean {
    if (!lua || !lua.duration || !lua.duration_unit) return false;

    const durationInMs =
      lua.duration_unit === "menit"
        ? lua.duration * 60 * 1000
        : lua.duration_unit === "jam"
        ? lua.duration * 60 * 60 * 1000
        : lua.duration_unit === "hari"
        ? lua.duration * 24 * 60 * 60 * 1000
        : 0;
    const expectedTime = new Date(row.authored_at).getTime() + durationInMs;

    return Date.now() > expectedTime && !row.stopped_at;
  }
}
